'use client';

import React, { createContext, useContext, useState } from 'react';

interface ContactModalContextType {
    isOpen: boolean;
    openModal: () => void;
    closeModal: () => void;
}

const ContactModalContext = createContext<ContactModalContextType>({
    isOpen: false,
    openModal: () => {},
    closeModal: () => {},
});

export function ContactModalProvider({ children }: { children: React.ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <ContactModalContext.Provider value={{
            isOpen,
            openModal: () => setIsOpen(true),
            closeModal: () => setIsOpen(false),
        }}>
            {children}
        </ContactModalContext.Provider>
    );
}

export const useContactModal = () => useContext(ContactModalContext);
